import React, { useState } from "react";
import { Modal, Button, Image, Form } from "react-bootstrap";
import dpimg from "assets/img/dpmain.png";

const CommentSectionModal = ({ show, onHide, post }) => {
  const [showAllComments, setShowAllComments] = useState(false);
  const [expandedReplies, setExpandedReplies] = useState({});

  if (!post) {
    return (
      <Modal show={show} onHide={onHide} centered>
        <Modal.Body className="text-center">Loading comments...</Modal.Body>
      </Modal>
    );
  }

  const comments = post?.comments || [];
  const visibleComments = showAllComments ? comments : comments.slice(0, 4);

  const toggleReplies = (commentId) => {
    setExpandedReplies((prev) => ({
      ...prev,
      [commentId]: !prev[commentId],
    }));
  };

  return (
    <Modal show={show} onHide={onHide} centered fullscreen="sm-down" size="lg">
      <Modal.Header closeButton className="border-0">
        <div className="d-flex align-items-center w-100">
          <Image
            src={post.post_user_detail?.image || dpimg}
            roundedCircle
            width={45}
            height={45}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = dpimg;
            }}
          />
          <div className="ms-3">
            <strong>{post.post_user_detail?.name || "Unknown User"}</strong>
            <div className="text-light small">
              @{post.post_user_detail?.subtitle}
            </div>
          </div>
        </div>
      </Modal.Header>

      <Modal.Body style={{ maxHeight: "80vh", overflowY: "auto" }}>
        {comments.length === 0 ? (
          <p className="text-center fw-semibold mt-2 fs-5">No comments yet.</p>
        ) : (
          <>
            {visibleComments.map((comment) => {
              const replies = comment.replies || [];
              const showAllReplies = expandedReplies[comment.id];
              const visibleReplies = showAllReplies ? replies : replies.slice(0, 4);

              return (
                <div key={comment.id} className="d-flex align-items-start mb-3">
                  <Image
                    src={dpimg}
                    roundedCircle
                    width={35}
                    height={35}
                    className="me-2"
                  />
                  <div>
                    <div className="fw-bold d-flex align-items-center">
                      {comment.user?.name || "Anonymous"}
                      <small className="ms-2 text-muted x-small">
                        {new Date(comment.dateTime).toLocaleString()}
                      </small>
                    </div>
                    <div className="small">{comment.comment}</div>
                    <div className="text-muted small mt-1">
                      <span className="me-3">Reply</span>
                      <span>Like</span>
                    </div>

                    {replies.length > 0 && (
                      <div className="ms-4 mt-2">
                        {visibleReplies.map((reply) => (
                          <div key={reply.id} className="d-flex align-items-start mb-2">
                            <Image
                              src={dpimg}
                              roundedCircle
                              width={30}
                              height={30}
                              className="me-2"
                            />
                            <div>
                              <div className="fw-bold d-flex align-items-center">
                                {reply.user?.name || "Anonymous"}
                                <small className="ms-2 text-muted x-small">
                                  {new Date(reply.dateTime).toLocaleString()}
                                </small>
                              </div>
                              <div className="small">{reply.comment}</div>
                              <div className="text-muted small mt-1">
                                <span className="me-3">Reply</span>
                                <span>Like</span>
                              </div>
                            </div>
                          </div>
                        ))}

                        {replies.length > 2 && (
                         <span
                         onClick={() => toggleReplies(comment.id)}
                         style={{
                           cursor: "pointer",
                           fontWeight: "500", 
                           color: "#212529",      
                         }}
                       >
                         {showAllReplies ? "View less replies" : "View more replies"}
                       </span>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              );
            })}

            {comments.length > 4 && (
              <div className="text-center mt-3">
                <Button variant="outline-secondary" size="sm" onClick={() => setShowAllComments(!showAllComments)}>
                  {showAllComments ? "View less comments" : "View more comments"}
                </Button>
              </div>
            )}
          </>
        )}
      </Modal.Body>

      <Modal.Footer className="border-0">
        <Form className="w-100">
          <Form.Group className="d-flex align-items-center">
            <Image
              src={dpimg}
              roundedCircle
              width={30}
              height={30}
              className="me-2"
            />
            <Form.Control
              type="text"
              placeholder="Write a comment..."
              className="me-2"
            />
            <Button variant="link" className="p-0">
              <i className="fas fa-paper-plane fa-lg"></i>
            </Button>
          </Form.Group>
        </Form>
      </Modal.Footer>
    </Modal>
  );
};

export default CommentSectionModal;
